
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.5 10.576H3v.88h1V5.302H3v.879H2v-.44C2 3.077 4.467.88 7.5.88S13 3.077 13 5.742v.44h-1v-.88h-1v6.153h1v-.879h1v1.319c0 .726-.673 1.347-1.5 1.347H8.908c-.207-.51-.757-.879-1.408-.879-.827 0-1.5.592-1.5 1.319S6.673 15 7.5 15c.651 0 1.2-.368 1.408-.879H11.5c1.378 0 2.5-1.015 2.5-2.226v-1.4c.58-.182 1-.665 1-1.237V7.5c0-.572-.42-1.055-1-1.237v-.52C14 2.592 11.084 0 7.5 0S1 2.592 1 5.742v.52c-.58.183-1 .666-1 1.238v1.758c0 .727.673 1.318 1.5 1.318z","fill":"#E2E8F0"}})])
          )
        }
      }
    